import NewReplacement from './NewReplacement';

export default NewReplacement;
